const OtherVitalInfo = () => {
    return (
        <div id="other" className="vision-card">
            <h3>OTHER VITAL INFORMATION</h3>

            <div className="table-section-wrap">
                <table className="table-section">
                    <tbody>

                        <tr>
                            <td>10th BOARD PASS PERCENTAGE (2024/2025/2026)</td>
                            <td>100/100/100</td>
                            <td>12th BOARD PASS PERCENTAGE (2024/2025/2026)</td>
                            <td>98.9/100/98.8</td>
                        </tr>

                        <tr>
                            <td>WELLNESS TEACHER</td>
                            <td>MR. ADITYA SINGH </td>
                            <td>GRIEVANCE/COMPLAINT REDRESSAL OFFICER</td>
                            <td>MR. AJIT R. JAMES</td>
                        </tr>

                        <tr>
                            <td>MOBILE NUMBER OF GRIEVANCE/COMPLAINT REDRESSAL OFFICER</td>
                            <td>9794746654</td>
                            <td>EMAIL ID OF GRIEVANCE/COMPLAINT REDRESSAL OFFICER</td>
                            <td>Principal.njms7@gmail.com</td>
                        </tr>

                        <tr>
                            <td>NAME OF HEAD OF SEXUAL HARASSMENT COMMITTEE</td>
                            <td>MRS. REBEECA JAMES</td>
                            <td>MOBILE NUMBER OF HEAD OF SEXUAL HARASSMENT COMMITTEE</td>
                            <td>9565671530</td>
                        </tr>

                        <tr>
                            <td>EMAIL ID OF HEAD OF SEXUAL HARASSMENT COMMITTEE</td>
                            <td>REBECCAJAMESREEBU1982@GMAIL.COM</td>
                            <td>NAME OF CONTACT PERSON IN CASE OF EMERGENCY</td>
                            <td>MR. AJIT R. JAMES</td>
                        </tr>

                        <tr>
                            <td>MOBILE NUMBER OF CONTACT PERSON IN CASE OF EMERGENCY</td>
                            <td>9794746654</td>
                            <td>EMAIL ID OF CONTACT PERSON IN CASE OF EMERGENCY</td>
                            <td>Principal.njms7@gmail.com</td>
                        </tr>

                        <tr>
                            <td>NUMBER OF DOCTORS IN SCHOOL CLINIC</td>
                            <td>00</td>
                            <td>NUMBER OF NURSES IN SCHOOL CLINIC</td>
                            <td>00</td>
                        </tr>


                        <tr>
                            <td>NUMBER OF BEDS IN SCHOOL CLINIC</td>
                            <td>02 BED</td>
                            <td>LEVEL OF INVOLVEMENT OF SCHOOL IN CBSE ACTIVITIES</td>
                            <td>ACTIVE</td>
                        </tr>

                        <tr>
                            <td>10th BOARD PASS PERCENTAGE (2014/2015/2016)</td>
                            <td>00/100/100</td>
                            <td>12th BOARD PASS PERCENTAGE (2014/2015/2016)</td>
                            <td>00/00/00</td>
                        </tr>

                        <tr>
                            <td>DOES THE SCHOOL HAS EPF FACILITY FOR STAFF</td>
                            <td>YES</td>
                            <td>EPF REGISTRATION NUMBER</td>
                            <td>UPGKP0048053</td>
                        </tr>

                        <tr>
                            <td>MODE OF SALARY PAYMENT</td>
                            <td>bankpayment</td>
                            <td>NAME OF BANK WITH SALARY ACCOUNT</td>
                            <td>CENTRAL BANK Ribarachandrabhan, Deoria</td>
                        </tr>

                        <tr>
                            <td>ACADEMIC SESSION</td>
                            <td>APRIL TO MARCH</td>
                            <td>VACATION PERIOD</td>
                            <td>MAY TO JUNE</td>
                        </tr>


                        <tr>
                            <td>AUDITED BALANCE SHEET OF SCHOOL</td>
                            <td>VIEW</td>
                            <td>STAFF STATEMENT OF SCHOOL</td>
                            <td>VIEW</td>
                        </tr>

                        <tr>
                            <td colSpan="4" style={{ textAlign: "center", fontWeight: "700" }}>
                                BEST PRACTICES OF SCHOOL
                            </td>
                        </tr>

                        <tr>
                            <td colSpan="4">
                                Maintains Perfect Disciplined & Spoken English Campus,
                                Active Involvement of 9 – Co-curricular clubs Motivation
                                on Personality development,Giving stress on Personal
                                Cleanliness Active Participation In swachha Bharat Abhiyan.
                            </td>
                        </tr>

                    </tbody>
                </table>
            </div>
        </div>
    );
};

export default OtherVitalInfo;